<template>
    <div class="query">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            重名查询-->
<!--        </div>-->
        <van-cell-group>
            <van-field v-model="rename" clearable label="查询姓名:" placeholder="请输入姓名"/>
<!--            <verification-code-input @setVerificationCode="getVerificationCode"-->
<!--                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-if="listShow">
            <div class="boxList-item">
                <span>重名人数</span>
                <span>{{dataList.count}}</span>
            </div>
            <div class="boxList-item">
                <span>查询姓名:</span>
                <span>{{dataList.name}}</span>
            </div>
            <div class="boxList-item">
                <span>查询范围:</span>
                <span>湖北省</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {queryApiMap} from "@/api/query";
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "RenameQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                show: false,
                rename : '', // 姓名
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                listShow: false,//查询结果的显示与隐藏
                dataList:{} //用于查询后存放数据
            }
        },
        mounted(){
          this.logger.visit('107','0')
        },
        methods: {
            onConfirm(value) {
                this.value = value;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },
          submit() {
            if (!this.rename) {
              Toast('请输入姓名')
            } else if(!(/^[\u2E80-\uFE4F|·]{2,32}$/.test(this.rename))) {
              Toast('请输入正确的姓名')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                name: this.rename,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryName}`, data)
              this.show = false
              //关闭加载
              Toast.clear()
              if (res.data.succ) {
                const dataList = {
                  'count': res.data.data,
                  'name': this.rename
                }
                this.dataList = dataList
                this.listShow = true
              } else {
                Toast.fail('查询失败')
              }
              this.logger.visit('107','1')
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.rename) {
                    Toast('请输入姓名')
                } else if(!(/^[\u2E80-\uFE4F|·]{2,32}$/.test(this.rename))) {
                    Toast('请输入正确的姓名')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            name: this.rename,
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.queryName}`, data)
                        if (res.data.succ) {
                            Toast.clear()
                            const dataList = {
                                'count': res.data.data,
                                'name': this.rename
                            }
                            this.dataList = dataList
                            this.listShow = true
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        } else {
                            Toast.fail('查询失败')
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                        this.logger.visit('107','1')
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    @import "~@assets/css/public/Common.css";
</style>
